<template>
  <aside>
    <vs-sidebar
      style="background: #ebf9fc"
      hover-expand
      reduce
      v-model="active"
      open
      class=""
    >
      <!-- <template #logo>
        <div class="d-block">
          <img src="@/images/profilePic.png" alt="" />
        </div>

      </template> -->
    
      <p class="mt-5 text-center">{{ user_name }}</p>

      <vs-sidebar-item class="mt-3" to="/" id="home">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="511pt"
            viewBox="0 1 511 511.999"
            width="511pt"
          >
            <path
              d="m498.699219 222.695312c-.015625-.011718-.027344-.027343-.039063-.039062l-208.855468-208.847656c-8.902344-8.90625-20.738282-13.808594-33.328126-13.808594-12.589843 0-24.425781 4.902344-33.332031 13.808594l-208.746093 208.742187c-.070313.070313-.144532.144531-.210938.214844-18.28125 18.386719-18.25 48.21875.089844 66.558594 8.378906 8.382812 19.441406 13.234375 31.273437 13.746093.484375.046876.96875.070313 1.457031.070313h8.320313v153.695313c0 30.417968 24.75 55.164062 55.167969 55.164062h81.710937c8.285157 0 15-6.71875 15-15v-120.5c0-13.878906 11.292969-25.167969 25.171875-25.167969h48.195313c13.878906 0 25.167969 11.289063 25.167969 25.167969v120.5c0 8.28125 6.714843 15 15 15h81.710937c30.421875 0 55.167969-24.746094 55.167969-55.164062v-153.695313h7.71875c12.585937 0 24.421875-4.902344 33.332031-13.8125 18.359375-18.367187 18.367187-48.253906.027344-66.632813zm-21.242188 45.421876c-3.238281 3.238281-7.542969 5.023437-12.117187 5.023437h-22.71875c-8.285156 0-15 6.714844-15 15v168.695313c0 13.875-11.289063 25.164062-25.167969 25.164062h-66.710937v-105.5c0-30.417969-24.746094-55.167969-55.167969-55.167969h-48.195313c-30.421875 0-55.171875 24.75-55.171875 55.167969v105.5h-66.710937c-13.875 0-25.167969-11.289062-25.167969-25.164062v-168.695313c0-8.285156-6.714844-15-15-15h-22.328125c-.234375-.015625-.464844-.027344-.703125-.03125-4.46875-.078125-8.660156-1.851563-11.800781-4.996094-6.679688-6.679687-6.679688-17.550781 0-24.234375.003906 0 .003906-.003906.007812-.007812l.011719-.011719 208.847656-208.839844c3.234375-3.238281 7.535157-5.019531 12.113281-5.019531 4.574219 0 8.875 1.78125 12.113282 5.019531l208.800781 208.796875c.03125.03125.066406.0625.097656.09375 6.644531 6.691406 6.632813 17.539063-.03125 24.207032zm0 0"
            />
          </svg>
        </template>
        اﻟﺮﺋﺴﻴﺔ
      </vs-sidebar-item>
    

      <vs-sidebar-item class="mt-2" @click.native="logout()" id="logout">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="512"
            viewBox="0 0 512 512"
            width="512"
          >
            <g id="Solid">
              <path
                d="m480.971 239.029-90.51-90.509a24 24 0 0 0 -33.942 0 24 24 0 0 0 0 33.941l49.54 49.539h-262.059a24 24 0 0 0 -24 24 24 24 0 0 0 24 24h262.059l-49.54 49.539a24 24 0 0 0 33.942 33.941l90.51-90.51a24 24 0 0 0 0-33.941z"
              />
              <path
                d="m304 392a24 24 0 0 0 -24 24v24h-208v-368h208v24a24 24 0 0 0 48 0v-32a40 40 0 0 0 -40-40h-224a40 40 0 0 0 -40 40v384a40 40 0 0 0 40 40h224a40 40 0 0 0 40-40v-32a24 24 0 0 0 -24-24z"
              />
            </g>
          </svg>
        </template>
        ﺗﺴﺠﻴﻞ اﻟﺨﺮﻭﺝ
      </vs-sidebar-item>
    </vs-sidebar>
  </aside>
</template>
<script>
// const {autoUpdate} = require('electron-auto-update');
export default {
  data: () => ({
    active: "home",
    barcodeValue: "zeyad",
    user_name: JSON.parse(localStorage.getItem("heavenDashboardUser")).name,
  }),
  methods: {
    triggerUpdates() {
      // Assign the updater to a variable that you can call manually
      // const updater = autoUpdate();
      // // Call at some point later:
      // updater.triggerUpdateCheck();
    },
    printBarCode() {
      const { ipcRenderer } = require("electron");

      ipcRenderer.send("printBarCode");
    },
    logout() {
      this.$store.commit("Logout");
    },
  },
  computed: {
    notAdmin() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id != 1) {
        return true;
      } else {
        return false;
      }
    },
    moshref() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id == 3) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "../styles/sidebar.scss";

.vs-sidebar {
  svg {
    width: 25px;
    height: 25px;
  }
}
</style>
